
<div class="footer">
  <div class="copyright">
    Copyright
    <a-icon type="copyright" />
    <span v-html="copyright"></span>
  </div>
</div>
